"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _utils = require("MeetingsLib/utils/utils");

var _ProfileHeader = _interopRequireDefault(require("MeetingsLib/components/header/ProfileHeader"));

var _FreemiumUpgradeButton = _interopRequireDefault(require("MeetingsLib/components/freemium/FreemiumUpgradeButton"));

var _UsageTracker = require("MeetingsLib/tracking/UsageTracker");

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _getFreemiumViralLink = _interopRequireDefault(require("MeetingsLib/components/freemium/getFreemiumViralLink"));

var _paths = require("MeetingsLib/constants/paths");

var _time = require("MeetingsLib/constants/time");

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _default = (0, _createReactClass.default)({
  displayName: "BookingSummary",
  propTypes: {
    bookedDateTime: _propTypes.default.number.isRequired,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    embedded: _propTypes.default.bool.isRequired,
    isSalesStarter: _propTypes.default.bool,
    offline: _propTypes.default.bool,
    profile: _propTypes.default.instanceOf(_UserProfile.default),
    userTimezone: _propTypes.default.oneOf(_I18n.default.moment.tz.names()),
    onSuccess: _propTypes.default.func.isRequired,
    redirectUrl: _propTypes.default.string,
    allowRedirect: _propTypes.default.bool,
    portalId: _propTypes.default.number
  },
  getInitialState: function getInitialState() {
    return {
      timeTillRedirect: _time.REDIRECT_DELAY_IN_SECONDS
    };
  },
  componentDidMount: function componentDidMount() {
    this.props.onSuccess();
    (0, _UsageTracker.track)('meetingsLibViewScreen', {
      stage: 'summary'
    });

    if (this.willRedirect()) {
      this.redirectInterval = window.setInterval(this.updateTimeTillRedirect, _time.SECOND);
      this.redirectTimeout = window.setTimeout(this.redirectToCustomPage, _time.REDIRECT_DELAY_IN_SECONDS * _time.SECOND);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.redirectTimeout) {
      window.clearTimeout(this.redirectTimeout);
      this.redirectTimeout = null;
    }

    if (this.redirectInterval) {
      window.clearInterval(this.redirectInterval);
      this.redirectInterval = null;
    }
  },
  updateTimeTillRedirect: function updateTimeTillRedirect() {
    this.setState(function (state) {
      return {
        timeTillRedirect: state.timeTillRedirect > 1 ? state.timeTillRedirect - 1 : 1
      };
    });
  },
  redirectToCustomPage: function redirectToCustomPage() {
    (0, _utils.redirectToUrl)(this.props.redirectUrl, this.props.embedded);
  },
  willRedirect: function willRedirect() {
    var _this$props = this.props,
        redirectUrl = _this$props.redirectUrl,
        isSalesStarter = _this$props.isSalesStarter,
        allowRedirect = _this$props.allowRedirect;
    return redirectUrl && isSalesStarter && allowRedirect;
  },
  getPreMessageKey: function getPreMessageKey() {
    var offline = this.props.offline;
    var suffix = offline ? 'offline' : 'online';
    var redirect = this.willRedirect() ? 'redirect.' : '';
    return "summary.tagline." + redirect + suffix;
  },
  goToMeetingsPage: function goToMeetingsPage() {
    var embedded = this.props.embedded;
    (0, _UsageTracker.track)('meetingsLibClickPromoLink', {
      page: 'thank you'
    });
    var thankYouViralLink = (0, _getFreemiumViralLink.default)(_paths.THANKYOU_VIRAL_HUBS_CTA, this.props.portalId, embedded);
    window.open(thankYouViralLink, '_blank');
  },
  renderRedirectCountdown: function renderRedirectCountdown() {
    if (this.willRedirect()) {
      return _react.default.createElement(_UILoadingSpinner.default, {
        className: "p-top-4",
        layout: "centered",
        showLabel: true,
        label: _react.default.createElement(_FormattedMessage.default, {
          message: "summary.redirect",
          options: {
            seconds: this.state.timeTillRedirect
          }
        })
      });
    }

    return null;
  },
  renderAdvert: function renderAdvert() {
    var _this$props2 = this.props,
        isSalesStarter = _this$props2.isSalesStarter,
        branding = _this$props2.branding;

    if (isSalesStarter) {
      return null;
    }

    return _react.default.createElement(_UIFlex.default, {
      align: "center",
      justify: "center"
    }, _react.default.createElement(_FreemiumUpgradeButton.default, {
      handleButtonClick: this.goToMeetingsPage,
      branding: branding
    }));
  },
  render: function render() {
    var _this$props3 = this.props,
        embedded = _this$props3.embedded,
        bookedDateTime = _this$props3.bookedDateTime,
        userTimezone = _this$props3.userTimezone,
        profile = _this$props3.profile,
        offline = _this$props3.offline;
    var classes = (0, _classnames.default)('book-summary m-x-auto', {
      'p-top-12': !embedded
    });
    var shouldRenderDateTime = !this.willRedirect();
    return _react.default.createElement("div", {
      className: classes,
      "data-timestamp": bookedDateTime
    }, _react.default.createElement(_UICardWrapper.default, {
      className: "width-100 p-all-0 height-100"
    }, _react.default.createElement(_UICardSection.default, {
      className: "p-all-0 height-100"
    }, _react.default.createElement("div", {
      className: "m-x-4 p-y-11 p-x-3 text-center"
    }, _react.default.createElement(_ProfileHeader.default, {
      booked: true,
      offline: offline,
      profile: profile
    }), _react.default.createElement("p", {
      className: "text-center m-top-3"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: this.getPreMessageKey(),
      options: {
        fullName: (0, _utils.getLongDisplayName)(profile)
      }
    })), shouldRenderDateTime && _react.default.createElement(_H.default, {
      className: "m-bottom-1 m-top-5"
    }, _I18n.default.moment(bookedDateTime).tz(userTimezone).format('LL'), _react.default.createElement("br", null), _I18n.default.moment(bookedDateTime).tz(userTimezone).format('LT')), this.renderAdvert(), this.renderRedirectCountdown()))));
  }
});

exports.default = _default;
module.exports = exports.default;